var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRoomMeasurementsGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M72.6275 12.5647C72.473 12.4765 72.3957 12.4324 72.3323 12.4386C72.2746 12.4443 72.2222 12.4747 72.1887 12.5221C72.1519 12.574 72.1519 12.663 72.1519 12.8409V18.2204C72.1519 18.2867 72.1519 18.3198 72.1613 18.3495C72.1701 18.3769 72.1846 18.4021 72.204 18.4233C72.225 18.4464 72.2537 18.4629 72.3111 18.496L138.324 56.5281C138.478 56.6173 138.556 56.6619 138.619 56.6559C138.677 56.6504 138.73 56.6199 138.763 56.5726C138.8 56.5206 138.8 56.4312 138.8 56.2526V50.7913C138.8 50.6249 138.8 50.5417 138.776 50.4672C138.754 50.3985 138.718 50.3354 138.669 50.2821C138.616 50.2245 138.544 50.1832 138.399 50.1008L72.6275 12.5647Z",
    fill: "#B4C5D0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2325 87.4629C37.1659 87.5014 37.0825 87.4533 37.0825 87.3763V58.3114C37.0825 58.2393 37.1212 58.1729 37.1839 58.1374L50.7444 50.4516C50.8777 50.376 51.043 50.4723 51.043 50.6256V79.4261C51.043 79.4618 51.0239 79.4949 50.993 79.5127L37.2325 87.4629Z",
    fill: "#B4C5D0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4428 102.607C21.1063 102.416 21.1047 101.932 21.44 101.739L73.7324 71.6255C73.9629 71.4927 74.2464 71.492 74.4776 71.6235L126.966 101.485C127.303 101.676 127.303 102.162 126.967 102.354L74.1512 132.448C74.1206 132.465 74.083 132.466 74.0524 132.448L21.4428 102.607Z",
    fill: "#CDD9E2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M74.1017 138.418V88.1681L11.3584 51.9209V102.362L74.1017 138.418Z",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M74.1021 138.418V88.1681L136.845 51.9209V102.362L74.1021 138.418Z",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M74.1017 15.9248V66.1751L11.3584 102.422V51.98L74.1017 15.9248Z",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M136.848 102.362L74.1048 66.1738L11.3618 102.42L74.1048 138.417L136.848 102.362Z",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M136.848 51.9874L74.1048 15.7993L11.3618 52.0458L74.1048 88.0427L136.848 51.9874Z",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M86.9106 41.7314L100.883 49.8751V65.422L86.9106 57.4634V41.7314Z",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M108.585 54.3291L122.558 62.4729V78.0199L108.585 70.0612V54.3291Z",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoomMeasurementsGrey);
export default __webpack_public_path__ + "static/media/room_measurements_grey.a8952eeec4fa7671102dd5d41ab9807b.svg";
export { ForwardRef as ReactComponent };